// useSaveUserPreference.js
import { useState, useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { createUserPreference, switchCompany } from '../graphql';
import { showSuccessSnackbar } from '../components/snackBar/snakbar';
import { resetUserPreference } from '../redux/reducers/UserPreference';
import { fetchCompany } from '../redux/reducers/CompanySlice';
import { useBroadcastChannel } from './useBroadcastChannel';

const useSaveUserPreference = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { sendMessage } = useBroadcastChannel('app-events', {});

  const saveUserPreference = useCallback(
    async (selectedFyID, changedCompanyID, action, message) => {
      setLoading(true);
      setError(null);

      try {
        // const resSwitch = await API.graphql(
        //   graphqlOperation(switchCompany, {
        //     companyid: changedCompanyID,
        //     financialyearid: selectedFyID,
        //   })
        // );

        // if (action !== 'bgUpdate') {
        //   showSuccessSnackbar(message);
        // }
        // dispatch(resetUserPreference());
        // dispatch(fetchCompany());
        // dispatch({ type: 'resetApi' });

        await API.graphql(
          graphqlOperation(switchCompany, {
            companyid: changedCompanyID,
            financialyearid: selectedFyID,
          })
        );

        if (action !== 'bgUpdate') {
          showSuccessSnackbar(message);
        }
        dispatch(resetUserPreference());
        await dispatch(fetchCompany());
        dispatch({ type: 'resetApi' });

        // Notify other tabs to navigate home (same as NavBar / CompanyList switch path)
        if (action !== 'bgUpdate') {
          sendMessage(
            'onSwitchCompany',
            message || 'Company or Financial Year switched!'
          );
        }
      } catch (err) {
        console.error('Error saving user preference:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [navigate, dispatch, sendMessage]
  );

  return { saveUserPreference, loading, error };
};

export default useSaveUserPreference;
